import { render, staticRenderFns } from "./ShippingCostInquiryNew.vue?vue&type=template&id=47da99d0"
import script from "./ShippingCostInquiryNew.vue?vue&type=script&lang=js"
export * from "./ShippingCostInquiryNew.vue?vue&type=script&lang=js"
import style0 from "./ShippingCostInquiryNew.vue?vue&type=style&index=0&id=47da99d0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47da99d0')) {
      api.createRecord('47da99d0', component.options)
    } else {
      api.reload('47da99d0', component.options)
    }
    module.hot.accept("./ShippingCostInquiryNew.vue?vue&type=template&id=47da99d0", function () {
      api.rerender('47da99d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/ShippingCostInquiryNew.vue"
export default component.exports